import { FC, useState } from 'react'
import { ClearIcon } from '@mui/x-date-pickers'
import { IconButton, InputAdornment, SxProps, TextField } from '@mui/material'

interface IProps {
  onSearch: (value: string) => void
  label?: string
  sx?: SxProps
  fullWidth?: boolean
}

const Search: FC<IProps> = ({
  onSearch,
  label = 'Search',
  sx = null,
  fullWidth = false,
}) => {
  const [search, setSearch] = useState('')

  const handleClear = () => {
    setSearch('')
    onSearch('')
  }

  const handleChange = (value: string) => {
    onSearch(value)
    setSearch(value)
  }

  return (
    <TextField
      value={search}
      data-testid="searchTextField"
      label={label}
      onChange={(evt) => handleChange(evt.target.value)}
      size="small"
      sx={sx}
      fullWidth={fullWidth}
      inputProps={{ 'data-testid': 'search' }}
      InputProps={{
        sx: {
          paddingRight: 0.5,
        },
        endAdornment: search && (
          <InputAdornment position="end">
            <IconButton onClick={handleClear} data-testid="clearButton">
              <ClearIcon sx={{ fontSize: '1.2rem' }} />
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  )
}

export default Search
